import axios from 'axios';
import types from './actionsTypes';
import config from '../../config';
import { handleSnackBar } from '../global/actions';
import { batch } from 'react-redux';
const API_URL = config.apiUrl;

const setProfileData = (payload = {}) => ({ type: types.SET_CONFGURATION_DATA, payload });

const getProfileConfigurationData = () => async (dispatch) => {
  try {
    const response = await axios({
      method: 'GET',
      url: API_URL + 'configuration',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.data.success) {
      dispatch(setProfileData(response.data.data));
    }
    return response;
  } catch (error) {
    dispatch(handleSnackBar({ open: true, message: `Could not fetch the configuration value`, severity: 'error' }));
  }
};

const saveProfileConfigurationData = (data) => async (dispatch) => {
  try {
    const response = await axios({
      method: 'POST',
      url: API_URL + 'configuration',
      headers: {
        'Content-Type': 'application/json',
      },
      data: data,
    });

    if (response.data.success) {
      batch(() => {
        dispatch(handleSnackBar({ open: true, message: response.data.message, severity: 'success' }));
        dispatch(getProfileConfigurationData());
      });
    } else {
      dispatch(handleSnackBar({ open: true, message: response.data.message, severity: 'error' }));
    }
    return response.data;
  } catch (error) {
    dispatch(handleSnackBar({ open: true, message: `Could not fetch the configuration value`, severity: 'error' }));
  }
};

const deleteProfileConfigurationData = (id) => async (dispatch) => {
  try {
    const response = await axios({
      method: 'DELETE',
      url: API_URL + 'configuration/' + id,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.data.success) {
      batch(() => {
        dispatch(handleSnackBar({ open: true, message: response.data.message, severity: 'success' }));
      });
    }
    return response;
  } catch (error) {
    dispatch(handleSnackBar({ open: true, message: `Could not fetch the configuration value`, severity: 'error' }));
  }
};

const editProfileConfigurationData = (data) => async (dispatch) => {
  try {
    const response = await axios({
      method: 'PUT',
      url: API_URL + 'configuration/' + data._id,
      headers: {
        'Content-Type': 'application/json',
      },
      data: data,
    });

    if (response.data.success) {
      batch(() => {
        dispatch(handleSnackBar({ open: true, message: response.data.message, severity: 'success' }));
        dispatch(getProfileConfigurationData());
      });
    }
    return response?.data;
  } catch (error) {
    dispatch(handleSnackBar({ open: true, message: `Could not fetch the configuration value`, severity: 'error' }));
  }
};

//Not a redux function need to updated to redux
export const getConfigarationList = async () => {
  const response = await axios({
    method: 'GET',
    url: API_URL + 'configuration-list',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return (response && response.data && response.data.data) || [];
};
//

export default {
  getProfileConfigurationData,
  saveProfileConfigurationData,
  getConfigarationList,
  editProfileConfigurationData,
  deleteProfileConfigurationData,
};
